import axios from 'axios'
import { showServerUpdateNotification } from '@/services/server-update-notification'
import getApiRoot from '@/services/api-root'

export const INTERNET_CONNECTION_ERROR_MESSAGE =
  'Your internet connection seems unstable or slow. Please check your network and try again.'

const VERIFICATION_URL = '/api/healthcheck'
const VERIFICATION_TIMEOUT = 5000

const verificationClient = axios.create({
  baseURL: getApiRoot(),
  timeout: VERIFICATION_TIMEOUT,
  withCredentials: true
})

export const isNetworkConnectionError = error => {
  if (!error || error.code === 'ERR_CANCELED') {
    return false
  }

  if (!error.response) {
    return true
  }

  return error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT' || String(error.message || '').includes('timeout')
}

export const internetSpeedAllowed = async () => {
  try {
    const response = await verificationClient.get(VERIFICATION_URL, {
      responseType: 'arraybuffer'
    })

    return response.status >= 200 && response.status < 300
  } catch (error) {
    if (error?.response?.status === 503) {
      showServerUpdateNotification()

      return true
    }

    return false
  }
}

export const checkInternetConnection = async () => {
  try {
    if (typeof navigator !== 'undefined' && navigator.onLine === false) {
      return false
    }

    let speedAllowed = await internetSpeedAllowed()

    if (!speedAllowed) {
      speedAllowed = await internetSpeedAllowed()
    }

    return speedAllowed
  } catch (_) {
    return false
  }
}
